<!--推荐设计师列表-->
<template>
	<div class='recommend-content'>
		<ul>
			<li v-for="(item,index) in formData" :key="index" @click="handleGetUserInfo(item.id)">
				<div class="user-info">
					<div style="position:relative;">
						<el-avatar :src="item.avatar_info" :title="item.nickname"/>
						<img v-if="item.is_member" class="user-vip" :src="getSettingConfig.getInfo('vip_icon')" alt="">
					</div>
					<div class="info">
						<p style="display: flex;align-items: center;flex-wrap: nowrap">
							<span class="lg-list-title lg-text-ell" style="max-width: 100px;display: inline-block">{{item.nickname}}</span>
							<el-rate :colors="colors" :value="item.user_rate === null || parseFloat(item.user_rate)=== 0 ? 5 :parseFloat(item.user_rate)" text-color="#ffde00" disabled :allow-half="true" />
						<p style="white-space: nowrap"><span class="lg-list-item" style="white-space: nowrap">工作经验：{{item.work_year}}年</span><span class="lg-list-item" style="white-space: nowrap">{{item.user_level}}</span></p>
						<div v-if="user_id !== item.id">
							<button @click.stop="handleGetFollow(item)">{{item.is_follow ? '已关注':'关注'}}</button>
							<button @click.stop="handleSendMessage(item.id)">私信</button>
						</div>
					</div>
				</div>
				<div class="work-info" v-for="(str,index) in item.materials" :key="str.id" @click.stop="handleGetDetail(str.id,index)">
					<el-image
						:src="str.thumb"
						fit="cover" :title="str.title"></el-image>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
  export default {
    name: "list",
    props:['formData'],
    data() {
      return {
        user_id:0,
        colors:['#ffde00','#ffde00','#ffde00','#ffde00','#ffde00'],
      }
    },
    created() {
      this.user_id = localStorage.getItem('user-info') ? JSON.parse(localStorage.getItem('user-info')).id : 0
    },
    methods: {
      handleGetDetail(data,index){
        // index <= 4 ? this.$router.push({name:'work_detail',query:{id:data}}):this.$router.push({name:'designer_detail',query:{id:data}})
        const {href} = this.$router.resolve({
          name: index <= 5 ? 'work_detail':'designer_detail',
          query: {
            id:data
          }
        })
        window.open(href, '_blank')
      },
      // 设计师主页
      handleGetUserInfo(data){
        const {href} = this.$router.resolve({
          name: 'designer_detail',
          query: {
            id:data
          }
        })
        window.open(href, '_blank')
      },
      // 关注
      handleGetFollow(data){
        const status = this.$utils.loginStatus()
        if (status) {
          data.is_follow = !data.is_follow
          this.$utils.upFollower(data.id)
        }
      },
      // 私信
      handleSendMessage(data){
        const status = this.$utils.loginStatus()
        if (status) {
          this.$utils.sendMessage({
            type:'client',
            id:data,
            message:''
          })
        }
      }
    },
  }
</script>

<style scoped lang='less'>
	.recommend-content{
		margin-top: 30px;
		ul{
			background-color: #FFFFFF;
			padding-top: 10px;
			border-radius: 6px;
			li{
				display: flex;
				align-items: center;
				cursor: pointer;
				margin: 0 20px;
				padding: 15px 0;
				.user-info{
					display: flex;
					align-items: center;
					width: 320px;
					/deep/ .el-avatar{
						width: 68px;
						height: 68px;
						margin-right: 25px;
					}
					/deep/ .el-rate{
						margin-top: 0 !important;
						position: relative;
						top: 1px;
						margin-left: 10px;
						.el-rate__icon{
							margin-right: 0;
							font-size: 16px;
						}
						.el-rate__text{
							margin-left: 10px;
						}
					}
					.user-vip{
						width: auto;
						height: auto;
						max-width: 18px;
						max-height: 18px;
						position: absolute;
						left: 52%;
						top: 65%;
					}
					.info{
						p:nth-child(2){
							margin-top: 5px;
							span:not(:last-child):after{
								content: "|";
								font-size: 12px;
								color: #8d92a1;
								margin: 0 10px;
							}
						}
						.rate{
							color: #ffde00;
							font-size: 14px;
							position: relative;
							top: 2px;
						}
						.rate-icon{
							margin:0 5px;
						}
						.name{
							max-width: 50%;
							display: inline-block;
						}
						div{
							button{
								display: inline-block;
								margin-top: 5px;
								font-size: 12px;
								padding: 1px 5px 2px;
								border: 1px solid #BFBFBF;
								background-color: #FFFFFF;
								border-radius: 4px;
								color: #8d92a1;
								white-space: nowrap;
							}
							button:nth-child(1){
								background-color: #ffde00;
								border-color: #ffde00;
								color: #FFFFFF;
								margin-right: 10px;
							}
						}
					}
				}
				.work-info{
					position: relative;
					margin-right: 23px;
					border-radius: 6px;
					.el-image{
						width: 170px;
						height: 100px;
						border-radius: 6px;
					}
				}
			}
			li:not(:last-child){
				border-bottom: 1px solid #F4F4F4;
			}
			li:last-child{
				margin-bottom: 30px;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/views/recommend/list.vue